module.exports = __webpack_public_path__ + "img/input_pin_hover.8ac1df59.png";